import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2.5rem;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const Header = styled.h2`
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: space-between;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
  padding-top: 6px;
`;

type StatusLoteTipo = "ABERTO" | "FECHADO" | "ENVIADO" | "ENTREGUE" | "FINALIZADO";

const tagStyleStrategy: Record<StatusLoteTipo, { background: string; color: string }> = {
  ABERTO:     { background: "#D1FAE5", color: "#059669" },
  FECHADO:    { background: "#DBEAFE", color: "#1D4ED8" },
  ENVIADO:    { background: "#FEF3C7", color: "#D97706" },
  ENTREGUE:   { background: "#EDE9FE", color: "#7C3AED" },
  FINALIZADO: { background: "#E5E7EB", color: "#6B7280" },
};

interface TagProps {
  tipo: StatusLoteTipo;
}

export const Tag = styled.div<TagProps>`
  background-color: ${({ tipo }) => tagStyleStrategy[tipo]?.background ?? "#E5E7EB"};
  border: 1px solid ${({ tipo }) => tagStyleStrategy[tipo]?.color ?? "#6B7280"};
  border-radius: 50px;
  color: ${({ tipo }) => tagStyleStrategy[tipo]?.color ?? "#6B7280"};
  padding: 5px 8px;
  text-align: center;
  width: 100px;
`;
